import { useMutation } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const MUTATION = graphql(`
  mutation CreatePrintRule($input: CreatePrintRuleInput!) {
    createPrintRule(input: $input) {
      id
      name
      menuId
    }
  }
`);

export function useCreatePrintRule() {
  return useMutation(MUTATION, {
    refetchQueries: ['PrintRuleList'],
  });
}
